export default __webpack_public_path__ + "static/media/로보엠디_이용약관_0511.9e0cf636.pdf";